export function parseEmailRoster(csv: string): Array<{
  email: string;
  fullName: string;
}> {
  const lines = csv
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
  if (lines.length === 0) return [];

  const first = lines[0].toLowerCase();
  const hasHeader = first.includes("email");
  return lines.slice(hasHeader ? 1 : 0).flatMap((line) => {
    const [email = "", fullName = ""] = line
      .split(",")
      .map((value) => value.trim().replace(/^"|"$/g, ""));
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
      ? [{ email: email.toLowerCase(), fullName }]
      : [];
  });
}

export function downloadCsv(filename: string, rows: Array<Array<string | number>>) {
  const body = rows
    .map((row) =>
      row
        .map((value) => `"${String(value).replaceAll('"', '""')}"`)
        .join(","),
    )
    .join("\n");
  const url = URL.createObjectURL(new Blob([body], { type: "text/csv" }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
